module.exports = __webpack_public_path__ + "static/media/softwareInstallation.c47b9bec.jpg";